import { Box, Grid } from "@mui/system";
import { LiveCodeBlock } from "../../LiveCodeBlock";
import { RecapCard } from "../../RecapCard";
import VerticalLinearStepper from "../VerticalLinearStepper";
import { Divider } from "@mui/material";

export const KdappontCssLesson2 = () => {
  const subjectBlocks = [
    {
      label: "CSS Backgrounds",
      main: (
        <>
          <Grid container columns={6} spacing={2}>
            <Grid size={4}>
              <LiveCodeBlock
                live={false}
                code={`section {
  background-color: green;
}

section.alternative {
  background-color: yellow;
}`}
                language="css"
              />{" "}
              <br />
              <LiveCodeBlock
                live={false}
                code={`<section>CSS is awesome #1</section>
<section class="alternative">CSS is awesome #2</section>`}
              />
            </Grid>

            <Grid size={2}>
              <section style={{ background: "green" }}>
                CSS is awesome #1
              </section>
              <section style={{ background: "yellow" }}>
                CSS is awesome #2
              </section>
            </Grid>
          </Grid>
          <br />
          <Divider />
          <br />
          <Grid container columns={6} spacing={2}>
            <Grid size={4}>
              <LiveCodeBlock
                live={false}
                code={`section {
  background-image: url("background.png");
}
section.no-repeat {
  background-repeat: no-repeat;
} 
section.top-right {
  background-position: top right;  /* Y-as en X-as */
}`}
                language="css"
              />{" "}
              <br />
              <LiveCodeBlock
                live={false}
                code={`<section>CSS is awesome #1</section>
<section class="no-repeat">CSS is awesome #2</section>
<section class="no-repeat top-right">CSS is awesome #3</section>`}
              />
            </Grid>

            <Grid size={2}>
              <section
                style={{
                  background:
                    "url('/presentation-data/KDAPPONT2/css/background.jpg')",
                }}
              >
                CSS is awesome #1
              </section>{" "}
              <br />
              <section
                style={{
                  background:
                    "url('/presentation-data/KDAPPONT2/css/background.jpg') no-repeat",
                }}
              >
                CSS is awesome #2
              </section>
              <br />
              <section
                style={{
                  background:
                    "url('/presentation-data/KDAPPONT2/css/background.jpg') no-repeat top right",
                }}
              >
                CSS is awesome #3
              </section>
            </Grid>
          </Grid>
        </>
      ),
    },
    {
      label: "CSS Borders",
      main: (
        <Grid container columns={6} spacing={2}>
          <Grid size={4}>
            <LiveCodeBlock
              live={false}
              code={`section.border-example {
  border-left-width: 2px;
  border-left-style: solid;
  border-left-color: orange;
  /* Kan sneller! */
  border-bottom: 5px dashed hotpink;
  border-top: 2px dotted grey;
  border-right: 2px solid orange;
}
section.border {
  /*Staat gelijk aan top, right, bottom, left */
  border: 5px solid red;
}`}
              language="css"
            />{" "}
            <br />
            <LiveCodeBlock
              live={false}
              code={`<section class="border-example">CSS is awesome #1</section>
<section class="border">CSS is awesome #2</section>`}
            />
          </Grid>

          <Grid size={2}>
            <section
              style={{
                borderLeft: "2px solid orange",
                borderBottom: "5px solid hotpink",
                borderTop: "2px dotted grey",
                borderRight: "2px solid orange",
              }}
            >
              CSS is awesome #1
            </section>
            <br />
            <section
              style={{
                border: "2px solid red",
              }}
            >
              CSS is awesome #2
            </section>
          </Grid>
        </Grid>
      ),
    },
    {
      label: "CSS Height/Width",
      main: (
        <Grid container columns={6} spacing={2}>
          <Grid size={4}>
            <LiveCodeBlock
              live={false}
              code={`section {
  width: 200px;
  height: 50px;
  background: red;
  border: 3px solid green;
}
section.percentage {
  width: 50%;
  height: 75%;
}`}
              language="css"
            />
            <br />
            <LiveCodeBlock
              live={false}
              code={`<section>CSS is awesome #1</section>
<section class="percentage">CSS is awesome #2</section>`}
            />
          </Grid>

          <Grid size={2}>
            <section
              style={{
                width: "200px",
                height: "50px",
                background: "red",
                border: "3px solid green",
              }}
            >
              CSS is awesome #1
            </section>
            <section
              style={{
                width: "75%",
                height: "75%",
                background: "red",
                border: "3px solid green",
              }}
            >
              CSS is awesome #2
            </section>
          </Grid>
        </Grid>
      ),
    },
    {
      label: "CSS Margin / Padding & Box Model",
      main: (
        <Grid container columns={6} spacing={2}>
          <Grid size={4}>
            <LiveCodeBlock
              live={false}
              code={`section { background: red }
section.margin {
  margin: 20px;
}
section.padding {         
  padding: 20px;
} 
section.complete {
  border: 5px solid hotpink;
  margin: 5px 30px 5px 30px; /* top right bottom left */
  padding: 50px 100px 0px 15px; /* top right bottom left */
}`}
              language="css"
            />
            <br />
            <LiveCodeBlock
              live={false}
              code={`<section>CSS is awesome #1</section>
<section class="margin">CSS is awesome #2</section>
<section class="padding">CSS is awesome #3</section>
<section class="complete">CSS is awesome #4</section>`}
            />
          </Grid>

          <Grid size={2}>
            <Box sx={{ border: "1px solid #ff5959ff" }}>
              <section
                style={{
                  background: "red",
                }}
              >
                CSS is awesome #1
              </section>
              <section
                style={{
                  background: "red",
                  boxSizing: "unset",
                  margin: "20px",
                }}
              >
                CSS is awesome #2
              </section>
              <section
                style={{
                  background: "red",
                  boxSizing: "unset",
                  padding: "20px",
                }}
              >
                CSS is awesome #3
              </section>
              <section
                style={{
                  background: "red",
                  boxSizing: "unset",
                  padding: "5px 30px",
                  margin: "50px 100px 0px 15px",
                  border: "5px solid hotpink",
                }}
              >
                CSS is awesome #4
              </section>
            </Box>
            <br />
            <Divider />
            <br />
            CSS Box Model
            <img
              src="/presentation-data/KDAPPONT2/css/box_model.png"
              width="100%"
              alt=""
            />
          </Grid>
        </Grid>
      ),
    },
  ];

  return (
    <VerticalLinearStepper
      steps={[
        {
          label: "🧠 CSS recap",
          description: "",
          content: (
            <Grid container>
              <Grid size={9}>
                <section>
                  <LiveCodeBlock
                    live={false}
                    code={`<!-- index.html -->
<!DOCTYPE html>
<html>
    <head>
        <link type="text/css" rel="stylesheet" href="stylesheet.css" />
    </head>

    <body>
      <h1>CSS is awesome</h1>
    </body>
</html>`}
                  />
                  <Divider />

                  <Box sx={{ position: "relative" }}>
                    <img
                      style={{
                        position: "absolute",
                        padding: 5,
                        background: "#FFF",
                        right: 125,
                        top: 50,
                        width: "50%",
                        borderRadius: "20px",
                        zIndex: 2,
                      }}
                      src="/presentation-data/KDAPPONT2/css-intro/css_selector.gif"
                      width="100%"
                      alt=""
                    />
                    <LiveCodeBlock
                      live={false}
                      language="css"
                      code={`/*stylesheet.css*/
h1 {
    color: green;
    font-family: Impact;
    font-size: 50px;
    text-align: center;
}`}
                    />
                  </Box>
                </section>
              </Grid>

              <Grid size={3}>
                <img
                  src="/presentation-data/KDAPPONT2/css-intro/css-result.png"
                  width="100%"
                  alt=""
                />
              </Grid>
            </Grid>
          ),
        },
        {
          label: "👨🏼‍🏫 Voor vandaag",
          description: `Backgrounds | Borders | Height & Width | Margin & Padding | Box Model`,
          content: (
            <Grid container columns={1} spacing={2}>
              {subjectBlocks.map((subject) => (
                <Grid size={1} sx={{ "& > *": { height: "100%" } }}>
                  <RecapCard subject={subject} />
                </Grid>
              ))}
            </Grid>
          ),
        },
      ]}
    />
  );
};
